// Plant scores come from the API (internal/score): 100 minus the points the
// plant's alerts took off over the last week, each alert weighted by its rule
// and by how long it was open. Rooms and sites average their plants.

export const SCORE_HINT = 'Plant health over the last 7 days, out of 100';

export const plantScoreClass = (score) => {
        if (score >= 90) return 'text-status-ok';
        if (score >= 50) return 'text-yellow-600';
        return 'text-status-critical';
};
